<template>
  <div class="Application-status">
    <h4>Granskningsstatus:</h4>
    <ToggleInput
      :value="application.markedAsReviewed"
      :text="
        application.markedAsReviewed ? 'Granskad och klar' : 'Ej färdiggranskad'
      "
      @input="handleStatusChange"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import ToggleInput from "@/components/forms/ToggleInput";
import { required } from "vuelidate/lib/validators";

export default {
  name: "ApplicationStatus",
  components: {
    ToggleInput
  },
  data() {
    return {
      editTypes: false,
      selectedTypes: []
    };
  },
  validations: {
    selectedTypes: {
      required
    }
  },
  computed: {
    ...mapState("applicationStore", ["application"])
  },

  methods: {
    ...mapActions("applicationStore", ["toggleMarkedAsReviewed"]),
    handleStatusChange(val) {
      this.toggleMarkedAsReviewed();
    }
  }
};
</script>

<style lang="scss" scoped>
.Application-status {
  padding-bottom: $spacing-L;
  .Form-input {
    @extend %paragraph;
    margin-bottom: $spacing-S/2;
  }

  &__button {
    width: 100%;
  }

  &__list {
    list-style: disc;
    margin-top: $spacing-S;
    margin-bottom: $spacing-S * 2;
    li {
      list-style: disc;
      margin-left: $spacing-L;
    }
  }
}
</style>
